module.exports = __webpack_public_path__ + "static/Logo_AVosID-f018fa3b06c07d8f5a0c7e8f8153b1dd.png";